import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { USER_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';

export interface UserBatchPayload {
  id?: number;
  name: string;
  status?: boolean;
  countryId: number;
}

@Injectable({
  providedIn: 'root',
})
export class UserBatchService {
  private readonly API = `${USER_URL}/userBatch`;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService,
  ) {}

  public getAll(
    pageIndex: number,
    pageSize: number,
    searchFilter?: string,
    status?: number,
    countryId?: number,
  ): Observable<any> {
    let url = `${this.API}/getAll?pageIndex=${pageIndex}&pageSize=${pageSize}`;

    if (searchFilter) {
      url += `&searchFilter=${encodeURIComponent(searchFilter)}`;
    }
    if (status !== undefined && status !== null) {
      url += `&status=${status}`;
    }
    if (countryId) {
      url += `&countryId=${countryId}`;
    }

    return this.http.get<any>(url).pipe(catchError(this.errorHandler.handleError));
  }

  public save(payload: UserBatchPayload): Observable<any> {
    return this.http
      .post<any>(`${this.API}/save`, payload)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public update(payload: UserBatchPayload): Observable<any> {
    return this.http
      .put<any>(`${this.API}/update`, payload)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public delete(id: number): Observable<any> {
    return this.http
      .delete<any>(`${this.API}/delete/${id}`)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public changeStatus(id: number): Observable<any> {
    return this.http
      .put<any>(`${this.API}/changeStatus/${id}`, null)
      .pipe(catchError(this.errorHandler.handleError));
  }
}
